(function () {
  const PRICE_BY_MONTHS = {
    3: 649,
    4: 829,
    5: 1009,
    6: 1150,
    7: 1329,
    8: 1509,
    9: 1749,
  };

  const CATEGORY_LABELS = {
    gravid: "Gravid",
    diabetes: "Diabetes",
    kraeft: "Kræftforløb",
    generel: "Generel",
  };

  const ALLOWED_MONTHS_BY_CATEGORY = {
    gravid: [3, 4, 5, 6, 7, 8, 9],
    diabetes: [3, 6, 9],
    kraeft: [3, 6, 9],
    generel: [3, 6, 9],
  };

  function initPreventiveFlow(root) {
    if (!root || root.dataset.preventiveInitialized === "true") return;
    root.dataset.preventiveInitialized = "true";

    const sectionId = root.dataset.sectionId;
    const byId = (id) => root.querySelector(`#${id}-${sectionId}`);

    const paymentUrl = root.dataset.paymentUrl || "/checkout";
    const fallbackCategory = root.dataset.defaultCategory || "generel";
    const fallbackMonths = Number(root.dataset.defaultMonths || 9);

    function detectCategoryFromReferrer() {
      try {
        const ref = (document.referrer || "").toLowerCase();
        if (!ref) return "";
        if (ref.includes("graviditetsforlob") || ref.includes("graviditetsforløb")) return "gravid";
        if (ref.includes("diabetesforlob") || ref.includes("diabetesforløb")) return "diabetes";
        if (ref.includes("kraeftforlob") || ref.includes("kræftforløb")) return "kraeft";
      } catch (_) {}
      return "";
    }

    const initialCategory = detectCategoryFromReferrer() || fallbackCategory;

    const state = {
      category: initialCategory,
      months: fallbackMonths,
      currentStep: 1,
      isSubmitting: false,
    };

    const monthButtons = root.querySelectorAll("[data-months]");
    const categoryButtons = root.querySelectorAll("[data-category]");
    const panels = root.querySelectorAll(".da-preventive-flow__panel");
    const stepButtons = root.querySelectorAll(".da-preventive-flow__step");
    const hasMultiStep = panels.length > 0;
    const progressFill = byId("progressFill");
    const submitButton = byId("submitButton");
    const errorEl = byId("error");
    const durationErrorEl = byId("durationError") || errorEl;
    const submitErrorEl = byId("submitError") || errorEl;
    const summaryCategory = byId("summaryCategory");
    const summaryDuration = byId("summaryDuration");
    const summaryPrice = byId("summaryPrice");
    const summaryKit = byId("summaryKit");
    const consentPolicyInput = byId("consentPolicy");
    const consentHealthInput = byId("consentHealth");
    const consentErrorEl = byId("consentError") || errorEl;

    function setErrorFor(target, message) {
      if (!target) return;
      target.textContent = message || "";
      if (message) {
        target.classList.add("is-visible");
      } else {
        target.classList.remove("is-visible");
      }
    }

    function setError(message) {
      setErrorFor(errorEl, message);
    }

    function hasRequiredConsents() {
      if (!consentPolicyInput || !consentHealthInput) return true;
      return Boolean(consentPolicyInput.checked && consentHealthInput.checked);
    }

    function updateSubmitButtonState() {
      if (!submitButton) return;
      submitButton.disabled = state.isSubmitting || !hasRequiredConsents();
    }

    function validateConsents() {
      if (hasRequiredConsents()) {
        setErrorFor(consentErrorEl, "");
        return true;
      }
      setErrorFor(consentErrorEl, "Du skal acceptere begge samtykker, før du kan gå til betaling.");
      return false;
    }

    function getAllowedMonths(category) {
      return ALLOWED_MONTHS_BY_CATEGORY[category] || ALLOWED_MONTHS_BY_CATEGORY.generel;
    }

    function getNearestAllowedMonth(months, allowedMonths) {
      if (allowedMonths.includes(months)) return months;
      let nearest = allowedMonths[0];
      let minDistance = Math.abs(months - nearest);
      allowedMonths.forEach((candidate) => {
        const distance = Math.abs(months - candidate);
        if (distance < minDistance || (distance === minDistance && candidate > nearest)) {
          nearest = candidate;
          minDistance = distance;
        }
      });
      return nearest;
    }

    function normalizeMonthsForCategory(months, category) {
      const allowedMonths = getAllowedMonths(category);
      return getNearestAllowedMonth(Number(months), allowedMonths);
    }

    function isKitIncluded(months, category) {
      if ((category || state.category) === "generel") return false;
      return Number(months) >= 6;
    }

    function validateStep(step) {
      if (step !== 2) return true;

      const allowedMonths = getAllowedMonths(state.category);
      if (!allowedMonths.includes(state.months)) {
        setErrorFor(durationErrorEl, "Vælg en gyldig varighed for det valgte forløb.");
        return false;
      }

      setErrorFor(durationErrorEl, "");
      return true;
    }

    function goToStep(step) {
      if (!hasMultiStep) return;

      panels.forEach((panel) => panel.classList.remove("is-active"));
      const targetPanel = root.querySelector(`[data-panel="${step}"]`);
      if (targetPanel) targetPanel.classList.add("is-active");

      stepButtons.forEach((stepButton, index) => {
        const stepNum = index + 1;
        stepButton.classList.remove("is-active", "is-completed");
        if (stepNum < step) stepButton.classList.add("is-completed");
        if (stepNum === step) stepButton.classList.add("is-active");
      });

      if (progressFill) {
        const totalSteps = Math.max(1, stepButtons.length || 3);
        progressFill.style.width = `${(step / totalSteps) * 100}%`;
      }

      state.currentStep = step;
      if (step === 3) {
        updateSummary();
        updateSubmitButtonState();
      }
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    function initNavigation() {
      if (!hasMultiStep) return;

      root.querySelectorAll("[data-next]").forEach((btn) => {
        btn.addEventListener("click", () => {
          const nextStep = Number(btn.dataset.next || 0);
          if (!nextStep) return;
          if (validateStep(state.currentStep)) {
            goToStep(nextStep);
          }
        });
      });

      root.querySelectorAll("[data-prev]").forEach((btn) => {
        btn.addEventListener("click", () => {
          const prevStep = Number(btn.dataset.prev || 0);
          if (prevStep) goToStep(prevStep);
        });
      });

      root.querySelectorAll("[data-goto]").forEach((btn) => {
        btn.addEventListener("click", () => {
          const gotoStep = Number(btn.dataset.goto || 0);
          if (gotoStep) goToStep(gotoStep);
        });
      });

      stepButtons.forEach((stepButton) => {
        stepButton.addEventListener("click", () => {
          const stepNum = Number(stepButton.dataset.step || 0);
          if (stepNum && stepNum < state.currentStep) {
            goToStep(stepNum);
          }
        });
      });
    }

    function getVariantId(category, months) {
      const categoryToken = String(category || "generel")
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "");
      const monthToken = String(months);
      const categoryPascal = categoryToken
        ? `${categoryToken.charAt(0).toUpperCase()}${categoryToken.slice(1)}`
        : "Generel";

      // Prefer direct data-attribute reads because dataset camelCase does not
      // normalize trailing numeric segments from names like data-variant-id-...-4.
      const specificAttr = root.getAttribute(`data-variant-id-${categoryToken}-${monthToken}`) || "";
      const baseAttr = root.getAttribute(`data-variant-id-${monthToken}`) || "";

      // Backwards-compatible fallbacks for earlier naming attempts.
      const specificKeyCamel = `variantId${categoryPascal}${monthToken}`;
      const specificKeyLower = `variantId${categoryToken}${monthToken}`;
      const baseKey = `variantId${monthToken}`;

      const specific = parseInt(
        specificAttr || root.dataset[specificKeyCamel] || root.dataset[specificKeyLower] || "0",
        10,
      );
      const base = parseInt(baseAttr || root.dataset[baseKey] || "0", 10);

      if (specific > 0) return specific;
      if (base > 0) return base;
      return 0;
    }

    function updateOptionStates() {
      const allowedMonths = getAllowedMonths(state.category);
      categoryButtons.forEach((btn) => {
        btn.classList.toggle("is-selected", btn.dataset.category === state.category);
      });
      monthButtons.forEach((btn) => {
        const monthValue = Number(btn.dataset.months);
        const available = allowedMonths.includes(monthValue);
        btn.classList.toggle("is-selected", monthValue === state.months);
        btn.classList.toggle("is-disabled", !available);
        btn.setAttribute("aria-disabled", available ? "false" : "true");
      });
    }

    function updateSummary() {
      if (summaryCategory) {
        summaryCategory.textContent = CATEGORY_LABELS[state.category] || CATEGORY_LABELS.generel;
      }
      if (summaryDuration) {
        summaryDuration.textContent = `${state.months} måneder`;
      }
      if (summaryPrice) {
        summaryPrice.textContent = `${PRICE_BY_MONTHS[state.months] || PRICE_BY_MONTHS[9]} kr.`;
      }
      if (summaryKit) {
        summaryKit.textContent = isKitIncluded(state.months, state.category)
          ? "Ja, kit medfølger"
          : "Nej, kit medfølger ikke";
      }
    }

    function setCategory(category) {
      state.category = category;
      state.months = normalizeMonthsForCategory(state.months, state.category);
      setError("");
      setErrorFor(durationErrorEl, "");
      updateOptionStates();
      updateSummary();
    }

    function setMonths(months) {
      const monthValue = Number(months);
      const allowedMonths = getAllowedMonths(state.category);
      if (!allowedMonths.includes(monthValue)) {
        setErrorFor(durationErrorEl, "Månederne 4, 5, 7 og 8 kan kun vælges for gravid-forløb.");
        return;
      }
      state.months = monthValue;
      setError("");
      setErrorFor(durationErrorEl, "");
      updateOptionStates();
      updateSummary();
    }

    async function handleSubmit(event) {
      event.preventDefault();
      if (state.isSubmitting) return;

      if (!validateConsents()) {
        updateSubmitButtonState();
        return;
      }

      const variantId = getVariantId(state.category, state.months);
      if (!variantId) {
        setErrorFor(submitErrorEl, "Manglende variant-id i section-indstillinger. Tilføj variant for valgt forløb.");
        updateSubmitButtonState();
        return;
      }

      state.isSubmitting = true;
      updateSubmitButtonState();
      setError("");
      setErrorFor(submitErrorEl, "");

      try {
        const categoryLabel = CATEGORY_LABELS[state.category] || CATEGORY_LABELS.generel;
        const addRes = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
                properties: {
                  action: "wellness_preventive",
                  kategori: categoryLabel,
                  plan_months: String(state.months),
                  kit_included: isKitIncluded(state.months, state.category) ? "ja" : "nej",
                },
              },
            ],
          }),
        });

        if (!addRes.ok) {
          const data = await addRes.json();
          throw new Error(data?.description || "Kunne ikke tilføje forløb til kurven");
        }

        window.location.href = paymentUrl;
      } catch (error) {
        console.error("Preventive flow error:", error);
        setErrorFor(submitErrorEl, error?.message || "Der opstod en fejl. Prøv igen.");
        state.isSubmitting = false;
        updateSubmitButtonState();
      }
    }

    categoryButtons.forEach((btn) => {
      btn.addEventListener("click", () => setCategory(btn.dataset.category || "generel"));
    });
    monthButtons.forEach((btn) => {
      btn.addEventListener("click", () => setMonths(btn.dataset.months || "9"));
    });
    [consentPolicyInput, consentHealthInput].forEach((input) => {
      if (!input) return;
      input.addEventListener("change", () => {
        if (hasRequiredConsents()) {
          setErrorFor(consentErrorEl, "");
        }
        updateSubmitButtonState();
      });
    });

    const form = byId("form");
    if (form) {
      form.addEventListener("submit", handleSubmit);
    }
    initNavigation();

    state.months = normalizeMonthsForCategory(state.months, state.category);
    updateOptionStates();
    updateSummary();
    updateSubmitButtonState();
    if (hasMultiStep) {
      goToStep(1);
    }

    window.addEventListener("pageshow", (event) => {
      if (!event.persisted) return;
      state.isSubmitting = false;
      setErrorFor(submitErrorEl, "");
      updateSubmitButtonState();
    });
  }

  function mountAll() {
    document.querySelectorAll(".da-preventive-flow").forEach(initPreventiveFlow);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mountAll);
  } else {
    mountAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event || !event.detail || !event.detail.sectionId) return;
    const root = document.getElementById(`da-preventive-flow-${event.detail.sectionId}`);
    initPreventiveFlow(root);
  });
})();

